// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 20px;
  }

  /* .format{
    font-size: 12px;
  } */
  
  .statsItem {
    flex: 1 1;
    margin: 10px 0;
    /* padding: 15px; */
    border-radius: 10px;
    cursor: pointer;
    background-color: white;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);
    border-left: 6px solid var(--primary-color);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .statsItem:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  
  .statsTitle {
    /* font-size: 20px; */
    /* font-weight: 700; */
    border-bottom: 2px solid grey;
    margin-bottom: 10px;
  }
  
  .complete {
    color: rgb(10, 85, 10);
  }
  
  .progress {
    color: orange;
  }
  
  .pending {
    color: rgb(235, 55, 55);
  }
  
  .statsContainer {
    text-align: right;
    font-size: 12px!important;
  }
  
  /* Dashboard Content Container */
  
  .dashboard-content {
    display: flex;
    width: 100%;
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    .dashboard-content {
      flex-wrap: wrap;
    }
    .chart-area {
      width: 100%;
    }
  }
  
  @media (max-width: 576px) {
    .dashboard-content {
      flex-wrap: wrap;
    }
    .chart-area {
      width: 100%;
    }
  }
  
  .dashboard-items {
    display: flex;
    flex: 1 1;
    gap: 20px;
  }
  
  /* Equal Size for Dashboard Items with different flex values */
  
  .arb-panel {
    flex: 1 1;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);
    border-left: 6px solid var(--primary-color);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-top: 20px;
    flex-basis: 40%; /* Adjust the width */
    cursor: pointer;
  }
  
  .arb-panel:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  
  .chart-area {
    flex: 1 1;
    border-radius: 10px;
    background-color: white;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);
    border-left: 6px solid var(--primary-color);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-top: 20px;
    flex-basis: 60%; /* Adjust the width */
    cursor: pointer;
  }
  
  .chart-area:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  
  .arb-header {
    background-color: var(--primary-color);
    color: var(--secondary-color);
    padding: 5px;
    text-align: center;
    font-size: 15px;
    border-top-right-radius: 10px;
  }
  
  .arb-list {
    padding: 10px;
  }
  
  .list-item {
    border-bottom: 1px solid #da8c0e9d;
    font-size: 12px!important;
  }
  
  .list-item p {
    margin: 0;
    /* padding: 2px; */
    /* font-size: 14px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .list-item:hover {
    background-color: var(--secondary-color);
    color: white;
  }
  
  .list-item span {
    background: white;
    border-radius: 50px;
    padding: 3px;
    color: var(--primary-color);
    font-size: 14px;
    font-weight: bold;
  }
  
  /* Chart Area */
  
  .chart-header {
    padding: 15px;
    border-bottom: 2px solid grey;
  }
  
  .chart-header h2 {
    margin: 0;
    font-size: 22px;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/dashboards/ResolutionDashboard/InstDashboardMain.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,SAAS;EACX;;EAEA;;KAEG;;EAEH;IACE,SAAO;IACP,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,uGAAuG;IACvG,2CAA2C;IAC3C,qDAAqD;EACvD;;EAEA;IACE,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,gCAAgC;;EAEhC;IACE,aAAa;IACb,WAAW;IACX,SAAS;EACX;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,WAAW;IACb;EACF;;EAEA;IACE;MACE,eAAe;IACjB;IACA;MACE,WAAW;IACb;EACF;;EAEA;IACE,aAAa;IACb,SAAO;IACP,SAAS;EACX;;EAEA,8DAA8D;;EAE9D;IACE,SAAO;IACP,mBAAmB;IACnB,uBAAuB;IACvB,uGAAuG;IACvG,2CAA2C;IAC3C,qDAAqD;IACrD,gBAAgB;IAChB,eAAe,EAAE,qBAAqB;IACtC,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,SAAO;IACP,mBAAmB;IACnB,uBAAuB;IACvB,uGAAuG;IACvG,2CAA2C;IAC3C,qDAAqD;IACrD,gBAAgB;IAChB,eAAe,EAAE,qBAAqB;IACtC,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,0EAA0E;EAC5E;;EAEA;IACE,sCAAsC;IACtC,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,wCAAwC;IACxC,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;EACnB;;EAEA,eAAe;;EAEf;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,eAAe;EACjB","sourcesContent":[".stats {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    gap: 20px;\n  }\n\n  /* .format{\n    font-size: 12px;\n  } */\n  \n  .statsItem {\n    flex: 1;\n    margin: 10px 0;\n    /* padding: 15px; */\n    border-radius: 10px;\n    cursor: pointer;\n    background-color: white;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);\n    border-left: 6px solid var(--primary-color);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .statsItem:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .statsTitle {\n    /* font-size: 20px; */\n    /* font-weight: 700; */\n    border-bottom: 2px solid grey;\n    margin-bottom: 10px;\n  }\n  \n  .complete {\n    color: rgb(10, 85, 10);\n  }\n  \n  .progress {\n    color: orange;\n  }\n  \n  .pending {\n    color: rgb(235, 55, 55);\n  }\n  \n  .statsContainer {\n    text-align: right;\n    font-size: 12px!important;\n  }\n  \n  /* Dashboard Content Container */\n  \n  .dashboard-content {\n    display: flex;\n    width: 100%;\n    gap: 20px;\n  }\n  \n  @media (max-width: 768px) {\n    .dashboard-content {\n      flex-wrap: wrap;\n    }\n    .chart-area {\n      width: 100%;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .dashboard-content {\n      flex-wrap: wrap;\n    }\n    .chart-area {\n      width: 100%;\n    }\n  }\n  \n  .dashboard-items {\n    display: flex;\n    flex: 1;\n    gap: 20px;\n  }\n  \n  /* Equal Size for Dashboard Items with different flex values */\n  \n  .arb-panel {\n    flex: 1;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);\n    border-left: 6px solid var(--primary-color);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    margin-top: 20px;\n    flex-basis: 40%; /* Adjust the width */\n    cursor: pointer;\n  }\n  \n  .arb-panel:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .chart-area {\n    flex: 1;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1), 0 6px 10px rgba(0, 0, 0, 0.15), 0 1px 18px rgba(0, 0, 0, 0.2);\n    border-left: 6px solid var(--primary-color);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    margin-top: 20px;\n    flex-basis: 60%; /* Adjust the width */\n    cursor: pointer;\n  }\n  \n  .chart-area:hover {\n    transform: scale(1.02);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15), 0 12px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .arb-header {\n    background-color: var(--primary-color);\n    color: var(--secondary-color);\n    padding: 5px;\n    text-align: center;\n    font-size: 15px;\n    border-top-right-radius: 10px;\n  }\n  \n  .arb-list {\n    padding: 10px;\n  }\n  \n  .list-item {\n    border-bottom: 1px solid #da8c0e9d;\n    font-size: 12px!important;\n  }\n  \n  .list-item p {\n    margin: 0;\n    /* padding: 2px; */\n    /* font-size: 14px; */\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .list-item:hover {\n    background-color: var(--secondary-color);\n    color: white;\n  }\n  \n  .list-item span {\n    background: white;\n    border-radius: 50px;\n    padding: 3px;\n    color: var(--primary-color);\n    font-size: 14px;\n    font-weight: bold;\n  }\n  \n  /* Chart Area */\n  \n  .chart-header {\n    padding: 15px;\n    border-bottom: 2px solid grey;\n  }\n  \n  .chart-header h2 {\n    margin: 0;\n    font-size: 22px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
